import { useState, useEffect } from 'react'
import AdditionalSalesView from '../../components/AdditionalSales/AdditionalSalesView'
import PlanningView from '../../components/AdditionalSales/PlanningView'
import ErrorBoundary from '../../components/ErrorBoundary'
import { setPageTitle } from '../../utils/pageTitle'

const AdditionalSales = () => {
  const [viewToShow, setViewToShow] = useState('additional-sales')

  useEffect(() => {
    setPageTitle('Ventes additionnelles')
    document.body.classList.add('additionalSalesBody')

    const script = document.createElement('script')
    script.innerHTML = `document.addEventListener('contextmenu', (event) => event.preventDefault())`
    document.body.appendChild(script)

    return () => {
      document.body.classList.remove('additionalSalesBody')
      document.body.removeChild(script)
    }
  }, [])

  return (
    <ErrorBoundary
      fallback={(reset) => {
        setTimeout(reset, 10 * 1000)
        return (
          <div>
            <img
              style={{ maxWidth: '100%' }}
              draggable="false"
              src="/additional-sales/bg-promo.webp"
              onClick={reset}
            />
          </div>
        )
      }}
    >
      <div className={`additionalSalesRoot ${viewToShow === 'planning' ? 'planningRoot' : ''}`}>
        <script></script>
        {viewToShow === 'additional-sales' && (
          <AdditionalSalesView changeView={() => setViewToShow('planning')} />
        )}
        {viewToShow === 'planning' && (
          <PlanningView
            changeView={() => {
              setViewToShow('additional-sales')
            }}
          />
        )}
      </div>
    </ErrorBoundary>
  )
}

export default AdditionalSales
